"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const configTypes_1 = require("./configTypes");
const cloudProvider_1 = __importDefault(
  require("workflow-model/dist/types/cloudProvider")
);
const getCloudProviderFromConfig = type => {
  switch (type) {
    case configTypes_1.CONFIG_TYPES.AWS_KEY:
    case configTypes_1.CONFIG_TYPES.AWS_ORG:
    case configTypes_1.CONFIG_TYPES.AWS_ORG_MEMBER:
    case configTypes_1.CONFIG_TYPES.AWS_PROXY:
    case configTypes_1.CONFIG_TYPES.AWS_ROLE:
      return cloudProvider_1.default.AWS;
    case configTypes_1.CONFIG_TYPES.AZURE:
      return cloudProvider_1.default.AZURE;
    case configTypes_1.CONFIG_TYPES.Kubernetes:
      return cloudProvider_1.default.Kubernetes;
    case configTypes_1.CONFIG_TYPES.TerraformCloud:
      return cloudProvider_1.default.TerraformCloud;
    case configTypes_1.CONFIG_TYPES.GCP:
      return cloudProvider_1.default.GCP;
    default:
      return cloudProvider_1.default.UNKNOWN;
  }
};
exports.default = getCloudProviderFromConfig;
//# sourceMappingURL=cloudProviderFromConfig.js.map
